import { assoc, curry } from "ramda"
import { isUndefined } from "../validate"

const setErrors = curry((errors, fieldProps) => {
  return !isUndefined(errors) ? assoc("errors", errors, fieldProps) : fieldProps
})

export default setErrors
